import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const updateDorumComment = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.FORUM_AREA.UPDATE_FORUM_COMMENT,
    data
  );
};

export default updateDorumComment;
